var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { width: "100%", elevation: "0" } },
    [
      _c("v-card-title", { staticClass: "pb-0 pl-1" }, [_vm._v("Tier Levels")]),
      _c("div", { staticClass: "pl-1" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "d-flex overline",
              staticStyle: { "align-items": "center", gap: "8px" },
            },
            [
              _c("b", { staticClass: "blue--text" }, [_vm._v("Low tier:")]),
              _c(
                "v-btn",
                {
                  attrs: { elevation: "0", "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addTier("lowTiers")
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex",
              staticStyle: { "flex-direction": "column", gap: "2px" },
            },
            _vm._l(_vm.lowTiers, function (tier, index) {
              return _c(
                "div",
                {
                  key: `low-${index}`,
                  staticClass:
                    "tl__rewards tl__rewards--low d-flex justify-space-between",
                  staticStyle: { gap: "8px", "align-items": "center" },
                },
                [
                  _c(
                    "v-expansion-panels",
                    { staticStyle: { width: "100%" } },
                    [
                      _c("r-reward-track-panel", {
                        attrs: { model: tier.rewards, title: "Reward" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(tier, "rewards", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    staticClass: "pt-0 mt-0",
                    attrs: {
                      label: "Min Level",
                      "hide-details": "",
                      type: "number",
                    },
                    model: {
                      value: tier.minLevel,
                      callback: function ($$v) {
                        _vm.$set(tier, "minLevel", _vm._n($$v))
                      },
                      expression: "tier.minLevel",
                    },
                  }),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "teal lighten-1" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.copyTier("lowTiers", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-content-copy ")]
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "red" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeTier("lowTiers", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "my-2" }, [
          _c(
            "div",
            {
              staticClass: "d-flex overline",
              staticStyle: { "align-items": "center", gap: "8px" },
            },
            [
              _c("b", { staticClass: "blue--text" }, [_vm._v("Middle tier:")]),
              _c(
                "v-btn",
                {
                  attrs: { elevation: "0", "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addTier("midTiers")
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex",
              staticStyle: { "flex-direction": "column", gap: "2px" },
            },
            _vm._l(_vm.midTiers, function (tier, index) {
              return _c(
                "div",
                {
                  key: `mid-${index}`,
                  staticClass:
                    "tl__rewards tl__rewards--mid d-flex justify-space-between",
                  staticStyle: { gap: "8px", "align-items": "center" },
                },
                [
                  _c(
                    "v-expansion-panels",
                    { staticStyle: { width: "100%" } },
                    [
                      _c("r-reward-track-panel", {
                        attrs: { model: tier.rewards, title: "Reward" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(tier, "rewards", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    staticClass: "pt-0 mt-0",
                    attrs: {
                      label: "Min Level",
                      "hide-details": "",
                      type: "number",
                    },
                    model: {
                      value: tier.minLevel,
                      callback: function ($$v) {
                        _vm.$set(tier, "minLevel", _vm._n($$v))
                      },
                      expression: "tier.minLevel",
                    },
                  }),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "teal lighten-1" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.copyTier("midTiers", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-content-copy ")]
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "red" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeTier("midTiers", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "d-flex overline",
              staticStyle: { "align-items": "center", gap: "8px" },
            },
            [
              _c("b", { staticClass: "blue--text" }, [_vm._v("High tier:")]),
              _c(
                "v-btn",
                {
                  attrs: { elevation: "0", "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addTier("highTiers")
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex",
              staticStyle: { "flex-direction": "column", gap: "2px" },
            },
            _vm._l(_vm.highTiers, function (tier, index) {
              return _c(
                "div",
                {
                  key: `high-${index}`,
                  staticClass:
                    "tl__rewards tl__rewards--high d-flex justify-space-between",
                  staticStyle: { gap: "8px", "align-items": "center" },
                },
                [
                  _c(
                    "v-expansion-panels",
                    { staticStyle: { width: "100%" } },
                    [
                      _c("r-reward-track-panel", {
                        attrs: { model: tier.rewards, title: "Reward" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(tier, "rewards", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    staticClass: "pt-0 mt-0",
                    attrs: {
                      label: "Min Level",
                      "hide-details": "",
                      type: "number",
                    },
                    model: {
                      value: tier.minLevel,
                      callback: function ($$v) {
                        _vm.$set(tier, "minLevel", _vm._n($$v))
                      },
                      expression: "tier.minLevel",
                    },
                  }),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "teal lighten-1" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.copyTier("highTiers", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-content-copy ")]
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "red" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeTier("highTiers", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }